<template>
  <div class="makc-footer">
    <div class="makc-footer__content">
      <div class="makc-footer__copyright">
        Ⓒ 2024 ООО «МАКС - Жизнь» info@makclife.ru<br>
        Лицензии СЖ №4013 от 13.08.2015, СЛ №4013 от 13.08.2015<br>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>

</style>